import React from 'react';
import styled from 'styled-components';
import { Images } from '../../../@resources/img';
import { withXmas } from './WithXmas';

const Frame = styled.div`
    display: flex;
    justify-content: center;
    padding: 1rem 1rem 0;

    img {
        max-height: 20rem;
    }
`;

export const XmasTree = withXmas(() => {
    return <Frame>
        <img src={Images.XmasTree} />
    </Frame>;
});
